import React from "react";
import { Link as RouterLink } from "react-router-dom";

export const CustomRouterLink = props => {
	if (!props.to) { // if 'to' is undefined, the page will break.
		return <a {...props}>{props.children}</a>;
	}

	return <RouterLink {...props}/>;
};